import React from "react";
import Page from "../../Page";
import styles from "../CenterMobileIRepairMobile/CenterMobileIRepairMobile.module.css";
import CenterMobileIRepairMobileBanner from "../CenterMobileIRepairMobileBanner/CenterMobileIRepairMobileBanner";
import CenterMobileIRepairMobileCallback from "../CenterMobileIRepairMobileCallback/CenterMobileIRepairMobileCallback";
import CenterMobileIRepairMobileInfo from "../CenterMobileIRepairMobileInfo/CenterMobileIRepairMobileInfo";
import CenterMobileIRepairMobileAdvantages from "../CenterMobileIRepairMobileAdvantages/CenterMobileIRepairMobileAdvantages";
import CenterMobileIRepairMobileOrderForm from "../CenterMobileIRepairMobileOrderForm/CenterMobileIRepairMobileOrderForm";
import CenterMobileIRepairMobilePrice from "../CenterMobileIRepairMobilePrice/CenterMobileIRepairMobilePrice";
import CenterMobileIRepairMobileSelect from "../CenterMobileIRepairMobileSelect/CenterMobileIRepairMobileSelect";
import BreadCrumbs from "../../BreadCrumbs/BreadCrumbs";
import htcBanner from "../../../images/banners/mobile-htc-banner.png";
import icon1 from "../../../images/icons/center-mobile-advantages-icon.svg";
import icon2 from "../../../images/icons/center-mobile-advantages-icon-house.svg";
import icon3 from "../../../images/icons/center-mobile-advantages-icon-car.svg";
import icon4 from "../../../images/icons/center-mobile-advantages-icon-rocket.svg";
import { desireHD, desire400 } from "../../../utils/CenterMobileHTCPriceList";
import { Helmet } from "react-helmet";

const contentForAdvantages = [
  {
    img: icon1,
    title: "БЫСТРЫЕ СРОКИ РЕМОНТА",
    text: "Если не включается телефон HTC, наличие комплектующих позволит выполнить ремонтные работы в самые оптимальные сроки, не заставляя наших клиентов ждать. А если вы совсем не можете обойтись без своего гаджета, мы предлагаем срочный ремонт смартфонов HTC в присутствии владельца.",
  },
  {
    img: icon2,
    title: "ДОСТАВКА СМАРТФОНА ТУДА И ОБРАТНО",
    text: "При ограничении во времени можно воспользоваться услугами курьера, который приедет за смартфоном в удобное для вас время. В этом случае наш сотрудник оформит и оставит вам все необходимые документы, а после ремонта доставит устройство обратно. В пределах МКАД в рабочее время доставка осуществляется бесплатно.",
  },
  {
    img: icon3,
    title: "ВЫЗОВ МАСТЕРА НА ДОМ",
    text: "При поломке, не требующей наличия сложного оборудования, ремонт смартфонов НТС может быть осуществлен на дому у клиента. Для более подробной информации можно обращаться по многоканальному телефону +7 (495) 540-43-19.",
  },
  {
    img: icon4,
    title: "ГАРАНТИЯ",
    text: "«Все ремонтные работы в «Центр Мобайл» сопровождаются предоставлением гарантии. Сроки выполнения гарантийных обязательств зависят от вида работ. Например, гарантия на замену комплектующих действует в течение полугодия, а на паяльные работы – на протяжении 3 месяцев.",
  },
];

const mobiles = [
  { name: "Desire HD", pricelist: desireHD },
  { name: "Desire 400", pricelist: desire400 },
  { name: "Desire 300", pricelist: desireHD },
  { name: "Desire SV", pricelist: desire400 },
  { name: "One M7", pricelist: desireHD },
  { name: "Butterfly S", pricelist: desire400 },
  { name: "One M8", pricelist: desireHD },
  { name: "Desire 600", pricelist: desire400 },
  { name: "One V", pricelist: desireHD },
  { name: "Desire X", pricelist: desire400 },
  { name: "Desire 500", pricelist: desireHD },
  { name: "Sensation XE", pricelist: desire400 },
  { name: "Desire 601", pricelist: desireHD },
  { name: "One S", pricelist: desire400 },
  { name: "One X", pricelist: desireHD },
  { name: "Butterfly", pricelist: desire400 },
  { name: "Desire S", pricelist: desireHD },
  { name: "Desire 310", pricelist: desire400 },
  { name: "Desire V", pricelist: desireHD },
  { name: "One mini", pricelist: desire400 },
];

const samsungMobilePrice = [
  {
    id: 1,
    text: "Диагностика",
    price: "Бесплатно",
    time: "30 минут",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 2,
    text: "Замена микросхем телефона",
    price: "от 900 P",
    time: "2-3 часа",
  },
  {
    id: 3,
    text: "Замена батареи",
    price: "от 300 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 4,
    text: "Замена экрана",
    price: "от 900 P",
    time: "2 часа",
  },
  {
    id: 5,
    text: "Ремонт цепи питания",
    price: "990 P",
    time: "3-4 часа",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 6,
    text: "Замена стекла",
    price: "от 800 P",
    time: "1-2 часа",
  },
  {
    id: 7,
    text: "Замена динамика",
    price: "от 280 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 8,
    text: "Замена разъема зарядки",
    price: "700-900 P",
    time: "1 час",
  },
  {
    id: 9,
    text: "Ремонт кнопки",
    price: "от 440 Р",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 10,
    text: "Замена задней крышки",
    price: "от 390 P",
    time: "4-5 часов",
  },
  {
    id: 11,
    text: "Ремонт системной платы",
    price: "1900 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
];

const samsungMobilePrice2 = [
  {
    id: 1,
    text: "Диагностика",
    price: "Бесплатно",
    time: "30 минут",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 2,
    text: "Восстановление прошивки",
    price: "890 P",
    time: "1 час",
  },
  {
    id: 3,
    text: "Чистка от жидкости",
    price: "890 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 4,
    text: "Восстановление данных",
    price: "890 P",
    time: "2-3 часа",
  },
  {
    id: 5,
    text: "Мелкий ремонт",
    price: "от 1500 P",
    time: "4-5 часов",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 6,
    text: "Чистка от пыли",
    price: "от 390 P",
    time: "1 час",
  },
  {
    id: 7,
    text: "Перепрошивка",
    price: "700 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
];

function CenterMobileRepairMobileHTC() {
  return (
    <Page title="Ремонт смартфонов HTC в Москве, сервисные услуги Oh!MyGadget!">
      <main className={styles.content}>
        <Helmet>
          <link
            rel="canonical"
            href="https://ohmygadget.ru/center-mobile/remont-smartfonov-htc"
          />
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Эффективный ремонт смартфонов HTC от квалифицированных специалистов Oh!MyGadget! (Москва). Оперативно, качественно, недорого. В наличии – полный ассортимент комплектующих для телефонов HTC."
          />
        </Helmet>
        <CenterMobileIRepairMobileBanner
          image={htcBanner}
          alt="смартфон HTC"
          title="смартфон HTC"
        />
        <BreadCrumbs />
        <CenterMobileIRepairMobileCallback />
        <CenterMobileIRepairMobileInfo
          title="РЕМОНТ СМАРТФОНОВ HTC"
          text="«Качество и надежность – главные принципы специалистов Oh!MyGadget!. Благодаря профессиональному подходу наших мастеров и современному техническому оснащению ремонт телефонов HTC осуществляется в рекордно короткие сроки, а качество работ подтверждается благодарными отзывами клиентов."
        />
        <CenterMobileIRepairMobileSelect
          title="Цены на ремонт HTC"
          text="Для уточнения стоимости услуг по ремонту, выберите вашу модель
            HTC:"
          mobiles={mobiles}
        />
        <CenterMobileIRepairMobileAdvantages
          title="РЕМОНТ HTC В «ЦЕНТР МОБАЙЛ»: НАШИ ПРЕИМУЩЕСТВА"
          titleMobile="Наши преимущества"
          contentForAdvantages={contentForAdvantages}
        />
        <CenterMobileIRepairMobileOrderForm
          title="КАК ОТРЕМОНТИРОВАТЬ СМАРТФОН В «ЦЕНТР МОБАЙЛ»?"
          text="Если у вас не работает телефон HTC, предлагаем связаться с нашими сотрудниками, воспользовавшись контактными данными из раздела «Контакты». Кроме номера телефона здесь размещен адрес электронной почты и удобная форма обратной связи. А зная наш адрес (Москва, ул. Лесная, 1/2, офис 351), можно привезти свой смартфон к нам самостоятельно."
        />
        <CenterMobileIRepairMobilePrice
          samsungMobilePrice={samsungMobilePrice}
          samsungMobilePrice2={samsungMobilePrice2}
        />
      </main>
    </Page>
  );
}

export default CenterMobileRepairMobileHTC;
